import React, { useEffect, useState } from 'react'
import { MainContainer } from '../../../theme'

function Referencechoices(props) {
  const [data, setData] = useState()
  const [correctAnswer, setCorrectAnswer] = useState()
  const [rightColumn, setRightColumn] = useState()
  const [leftColumn, setLeftColumn] = useState()
  const [counter, setCounter] = useState(0)
  const [leftCopyData, setLeftCopyData] = useState([])
  const [rightCopyData, setRightCopyData] = useState([])
  const [disableSelect, setDisableSelect] = useState(true)

  const {
    referenceIncorrectOption,
    referenceCorrectOption,
    reference,
    onSelect,
    quesId,
    submit,
    finalAttempt,
  } = props

  useEffect(() => {
    ;(async () => {
      let data = []
      if (referenceCorrectOption && referenceIncorrectOption) {
        for (let i = 0; i < referenceCorrectOption.length; i++) {
          let correctObj = { answer: 'correct', url: referenceCorrectOption[i] }
          data.push(correctObj)
        }
        await setCorrectAnswer({ answer: 'correct', url: reference })
        for (let i = 0; i < referenceIncorrectOption.length; i++) {
          let incorrectObj = {
            answer: 'wrong',
            url: referenceIncorrectOption[i],
          }
          data.push(incorrectObj)
        }
        data = data.sort(() => Math.random() - 0.5)
      }
      const half = Math.ceil(data.length / 2)
      const rightColumn = data.splice(0, half)
      const leftColumn = data.splice(-half)
      await setLeftColumn(leftColumn)
      await setRightColumn(rightColumn)
      await setData(data)
      setCounter(0)
    })()
  }, [referenceCorrectOption, referenceIncorrectOption, submit])

  useEffect(() => {
    if (finalAttempt && referenceCorrectOption.length == counter) {
      let leftcolumn = leftColumn.map((data) => {
        let obj = {}
        if (data?.answer === 'correct') {
          return (obj = { ...data, right: 'true' })
        } else {
          return (obj = { ...data })
        }
      })
      setLeftCopyData(leftcolumn)
      let rightcolumn = rightColumn.map((data) => {
        let obj = {}
        if (data?.answer === 'correct') {
          return (obj = { ...data, right: 'true' })
        } else {
          return (obj = { ...data })
        }
      })
      setRightCopyData(rightcolumn)
    } else {
      setLeftCopyData(leftColumn)
      setRightCopyData(rightColumn)
    }
  }, [finalAttempt, leftColumn, rightColumn])

  const setAnswerData = (answer, index, type, url) => {
    setCounter(counter + 1)

    onSelect(url, quesId, answer)
    let leftcolumnData = JSON.parse(JSON.stringify(leftColumn))
    let rightColumnData = JSON.parse(JSON.stringify(rightColumn))
    if (type == 'leftcolumn') {
      if (answer == 'correct') {
        leftcolumnData[index].right = 'true'
      } else {
        leftcolumnData[index].wrong = 'true'
      }
      setLeftColumn(JSON.parse(JSON.stringify(leftcolumnData)))
    } else {
      if (answer === 'correct') {
        rightColumnData[index].right = 'true'
      } else {
        rightColumnData[index].wrong = 'true'
      }
      setRightColumn(JSON.parse(JSON.stringify(rightColumnData)))
    }
  }

  return (
    <MainContainer
      borderRadius={'5px'}
      className="p-2 mt-2 d-flex justify-content-between align-items-center"
    >
      <div
        style={{ height: '80%', alignSelf: 'baseline'}}
        className="d-flex flex-column justify-content-between"
      >
        {leftCopyData?.map((option, index) => (
          <img
            style={{
              width: '95px',
              height: '110px',
              padding: '10px',
              borderRadius: '16%',
              marginBottom: '3px',
              marginTop: '3px'
            }}
            className={` ${
              option.right ? 'right' : option.wrong ? 'wrong' : ''
            }`}
            onClick={() =>
              !(referenceCorrectOption.length === counter) &&
              setAnswerData(option.answer, index, 'leftcolumn', option.url)
            }
            src={option.url}
          />
        ))}
      </div>
      <div>
        <img
          style={{
            width: '100px',
            height: '110px',
            padding: '10px',
            borderRadius: '16%',
          }}
          src={reference}
        />
      </div>
      <div
        style={{ height: '80%' }}
        className="d-flex flex-column justify-content-between "
      >
        {rightCopyData?.map((option, index) => (
          <img
            style={{
              width: '95px',
              height: '110px',
              padding: '10px',
              borderRadius: '16%',
            }}
            className={`m-1 ${
              option.right ? 'right' : option.wrong ? 'wrong' : ''
            }`}
            onClick={() =>
              !(referenceCorrectOption.length == counter) &&
              setAnswerData(option.answer, index, 'rightColumn', option.url)
            }
            src={option.url}
          />
        ))}
      </div>
    </MainContainer>
  )
}

export default Referencechoices
